// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ReadMoreButton = require("./ReadMoreButton").default;

var make = ReadMoreButton;

exports.make = make;
/* make Not a pure module */
